import { render, staticRenderFns } from "./ConfirmResetStock.vue?vue&type=template&id=60e4f382&"
import script from "./ConfirmResetStock.vue?vue&type=script&lang=js&"
export * from "./ConfirmResetStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports